import React from "react";
import { useField, Field } from "formik";
import InputMask from "react-input-mask";

interface PhoneNumberInputProps {
  name: string;
}

const rawMask = `+1 (___) ___-____`;

export function PhoneNumberInput(props: PhoneNumberInputProps) {
  const [field, , helpers] = useField(props.name);

  return (
    <Field
      id="phone"
      placeholder="Enter your phone number"
      type="text"
      component={InputMask}
      mask="+1 (999) 999-9999"
      value={field.value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        const rawValue = e.target.value;
        if (!rawValue || (rawValue === rawMask && !field.value)) {
          helpers.setValue("");
          return;
        }

        const justTheDigits = rawValue.match(/\d+/g)?.map(String).join("");
        helpers.setValue(justTheDigits);
      }}
      className="border-radius-primary w-full h-full border-[#C9CCCF] focus-primary focus-primary-border placeholder-subdued text-body"
      name={props.name}
    />
  );
}
